// Sales payment and customer catalog (Norwegian).
window.PlummeI18n.register('no', {
  'inv.unknownAccount': 'Ukjent konto',
  'inv.refund.customerBalance': "Til gode hos oss",
  'inv.refund.balanceHelp': "Saldoen inkluderer kreditnotaene og de registrerte inn- og tilbakebetalingene nedenfor.",
  'inv.refund.addFee': "Legg til gebyr",
  'inv.refund.businessFee': "Gebyr betalt av virksomheten",
  'inv.refund.customerReceives': "Kunden mottar",
  'inv.refund.accountDebit': "Samlet trekk fra kontoen",
  'sale.pay.ownerDebt': "Gjeld til eiere, kortsiktig",
  'sale.pay.title': 'Betaling',
  'sale.pay.help': 'Velg hvilken konto salget ble betalt til, og hvilken dato. Legg til gebyr eller del betalingen i flere innbetalinger. Totalen må stemme med salgslinjene.',
  'sale.pay.paidTo': 'Betalt til',
  'sale.pay.choosePaymentAccount': 'Velg betalingskonto',
  'sale.create.needPaymentAccount': 'Velg Betalt til før du registrerer salget.',
  'sale.pay.paidDate': 'Betalt dato',
  'sale.pay.fee': 'Gebyr',
  'sale.pay.addFee': 'Legg til gebyr',
  'sale.pay.removeFee': 'Fjern gebyr',
  'sale.pay.partial': 'Delbetalinger',
  'sale.pay.addPartial': 'Legg til delbetaling',
  'sale.pay.removePartial': 'Fjern delbetaling',
  'sale.pay.seeTransaction': 'Se transaksjon',
  'sale.pay.addAccount': 'Legg til konto',
  'sale.pay.addCard': 'Legg til kredittkort',
  'sale.pay.addBankTitle': 'Legg til bankkonto',
  'sale.pay.addCardTitle': 'Legg til kredittkort',
  'sale.pay.addSolutionTitle': 'Legg til betalingsløsning',
  'sale.pay.solution': 'Betalingsløsning',
  'sale.pay.accountType': 'Kontotype',
  'sale.pay.cardOwner': 'Kortet tilhører',
  'sale.pay.displayName': 'Visningsnavn (valgfritt)',
  'sale.pay.orgNumber': 'Org.nummer',
  'sale.pay.openingBalance': 'Startsaldo for avstemming',
  'sale.pay.openingBalanceDate': 'Dato for startsaldo',
  'sale.pay.resetChoice': 'Nullstill valg',
  'sale.cust.helpTitle': 'Kunde på salget',
  'sale.cust.help': 'Her velger du hvem salget gjelder. Søk opp en lagret kunde, liste eller abonnement — eller trykk «Ny kunde» for å skrive inn en mottaker som ikke er lagret fra før. Navn og adresse hentes inn på dokumentet automatisk.',
  'sale.cust.optionalHelp': 'Kunde er valgfritt på annet salg. Slå på hvis du vil knytte salget til en bestemt kunde.',
  'sale.cust.search': 'Søk i kunder, lister og abonnement...',
  'sale.cust.pickExisting': 'Velg eksisterende',
  'sale.cust.new': 'Ny kunde',
  'sale.cust.add': 'Legg til kunde',
  'sale.cust.selected': 'Valgt kunde',
  'sale.cust.selectedList': 'Valgt mottakerliste',
  'sale.cust.none': 'Ingen kunde valgt ennå',
  'sale.cust.listsAndSubs': 'Lister og abonnement',
  'sale.cust.detailsTitle': 'Kundedetaljer',
  'sale.cust.name': 'Kundenavn',
  'sale.cust.namePh': 'F.eks. Eksempel AS',
  'sale.cust.number': 'Kundenr',
  'sale.cust.org': 'Org.nr',
  'sale.cust.orgPh': '123 456 789',
  'sale.cust.address': 'Adresse',
  'sale.cust.addressPh': 'Gateadresse, postnr og sted',
  'sale.cust.email': 'E-post',
  'sale.cust.emailPh': 'post@eksempel.no',
  'sale.cust.phone': 'Telefon',
  'sale.cust.phonePh': '400 00 000',
  'sale.cust.contacts': 'Kontaktpersoner',
  'sale.cust.noContacts': 'Ingen kontaktpersoner lagt til.',
  'sale.cust.addContact': 'Legg til kontaktperson',
  'sale.cust.removeContact': 'Fjern kontaktperson',
  'sale.cust.contactName': 'Navn',
  'sale.cust.contactNamePh': 'F.eks. Kari Nordmann',
  'sale.cust.contactRole': 'Rolle',
  'sale.cust.contactRolePh': 'F.eks. Regnskap',
  'sale.cust.outstanding': 'Utestående',
  'sale.cust.revenueToDate': 'Omsetning hittil',
  'sale.cust.pickPh': 'Kunde eller nummer',
  'sale.cust.select': 'Velg kunde',
  'sale.cust.use': 'Bruk kunde',
  'sale.cust.noEmail': 'Ingen e-post på kunde',
  'sale.cust.listDefaultName': 'Kundeliste',
  'sale.cust.updatedToast': 'Kunde oppdatert i salget',
  'sale.cust.noCustomerHelp': 'Salget registreres uten kunde. Slå på bryteren hvis du vil knytte det til en kunde.',
  'sale.cust.selectHint': 'Velg en lagret kunde, liste eller abonnement - eller bruk Ny kunde for fri input.',
  'sale.cust.recipientsCount': '{count} mottakere',
  'sale.cust.kindSubscription': 'Abonnement',
  'sale.cust.kindList': 'Liste',
  'sale.cust.noMatches': 'Ingen treff på «{query}».',
  'sale.cust.addAsNew': 'Legg til «{query}» som ny kunde',
  'sale.cust.contactDefaultName': 'Kontaktperson {n}',
  'sale.cust.saveFailed': 'Kunne ikke lagre kunden.',
  'sale.pay.accountNameSavings': 'Sparekonto',
  'sale.pay.accountNameOperating': 'Driftskonto',
  'sale.pay.accountNamePrivate': 'Privatkonto',
  'sale.pay.accountNameBank': 'Bankkonto',
  'sale.pay.groupBank': 'Bankkontoer',
  'sale.pay.groupCard': 'Kredittkort',
  'sale.pay.groupPrivate': 'Privat',
  'sale.pay.groupOther': 'Annet',
  'sale.pay.groupGeneric': 'Kontoer',
  'sale.pay.cashLabel': 'Kontant',
  'sale.pay.bankNameRequired': 'Gi bankkontoen et navn',
  'sale.pay.accountOrCardNameRequired': 'Gi kontoen eller kortet et navn',
  'sale.pay.accountNumberRequired': 'Fyll inn kontonummer',
  'sale.pay.bankAccountAdded': 'Bankkonto lagt til',
  'sale.pay.privateAccountAdded': 'Privatkonto lagt til',
  'sale.pay.saveAccountFailed': 'Kunne ikke lagre konto.', 'sale.pay.accountsUnavailable': 'Betalingskontoer er ikke koblet til backend.', 'sale.pay.openingSetupRequired': 'Fyll inn oppstartsdato og startsaldo. Skriv 0 dersom saldoen var null.', 'sale.pay.invalidLedgerAccount': 'Mangler gyldig kontonummer i kontoplanen.', 'sale.pay.accountExists': 'Konto {code} finnes allerede.',
  'sale.pay.typePrivateCard': 'Privatkonto / kort',
  'sale.pay.newBankAccountNote': 'Ny bankkonto opprettes i kontoplanen',
  'sale.pay.newPrivateAccountNote': 'Ny privatkonto/kort opprettes i kontoplanen',
  'sale.pay.bankAccountSeriesInfo': 'Bankkontoer får neste ledige konto i 192x-serien.',
  'sale.pay.privateAccountSeriesInfo': 'Private kort/kontoer får neste ledige mellomregningskonto i 206x-serien.',
  'sale.pay.thisGetsAccount': 'Denne får konto',
  'sale.pay.accountNameLabel': 'Kontonavn',
  'sale.pay.accountOrCardNameLabel': 'Navn på konto / kort',
  'sale.pay.accountNamePhBank': 'F.eks. Driftskonto 2',
  'sale.pay.accountNamePhPrivate': 'F.eks. Eierkort Visa',
  'sale.pay.accountNumberLabel': 'Kontonummer',
  'sale.pay.accountCardRefLabel': 'Konto / kortnummer / referanse (valgfritt)',
  'sale.pay.interimAccountPrefix': 'Mellomregning',
  'sale.pay.cardNameRequired': 'Gi kredittkortet et navn',
  'sale.pay.cardNumberRequired': 'Fyll inn kort-/kontonummer',
  'sale.pay.openingBalanceRequired': 'Fyll inn startsaldo og dato for startsaldo',
  'sale.pay.creditCardDebtPrefix': 'Kredittkortgjeld',
  'sale.pay.cardAdded': 'Kredittkort lagt til',
  'sale.pay.saveCardFailed': 'Kunne ikke lagre kredittkort.',
  'sale.pay.scopeBusiness': 'Bedrift',
  'sale.pay.businessCardNote': 'Bedriftskort bokføres som egen kortgjeld',
  'sale.pay.privateCardNote': 'Privat kort bokføres som mellomregning',
  'sale.pay.businessCardSeriesInfo': 'Bedriftskort som ikke er bankkonto får neste ledige konto i 238x-serien.',
  'sale.pay.privateCardSeriesInfo': 'Private kort får neste ledige mellomregningskonto i 206x-serien.',
  'sale.pay.accountInLedger': 'Konto i regnskap:',
  'sale.pay.cardNamePhBusiness': 'F.eks. Firmakort Visa',
  'sale.pay.cardNamePhPrivate': 'F.eks. Eierkort Mastercard',
  'sale.pay.cardNumberLabel': 'Kortnummer / kontonummer',
  'sale.pay.cardNumberLabelOptional': 'Kortnummer / kontonummer (valgfritt)',
  'sale.pay.otherSolution': 'Annen betalingsløsning',
  'sale.pay.settlementPrefix': 'Oppgjør',
  'sale.pay.solutionAdded': 'Betalingsløsning lagt til',
  'sale.pay.saveSolutionFailed': 'Kunne ikke lagre betalingsløsning.',
  'sale.pay.solutionExplainer': 'Vipps, PayPal, iZettle, Stripe og lignende føres på en egen oppgjørskonto for betalingsløsningen, som avstemmes når oppgjøret er utbetalt til bankkontoen.',
  'sale.pay.addCardAction': '+ Legg til kredittkort ...',
  'sale.pay.addSolutionAction': '+ Legg til betalingsløsning ...',
  'sale.pay.partialLabel': 'Delbetaling {n}',
  'sale.pay.partialStatusRemaining': 'gjenstår',
  'sale.pay.partialStatusTooMuch': 'for mye',
  'sale.pay.partialStatusMatches': 'stemmer',
  'sale.pay.partialSummary': 'Betalt {paid} av {expected} · {status}',
  'sale.pay.partialMismatch': 'Summen av delbetalingene må stemme med salgstotalen{feeSuffix} ({expected}).', 'sale.list.noMembers': 'Listen har ingen kunder å fakturere.', 'sale.list.customerMissing': 'Kunden finnes ikke lenger.', 'sale.list.noneCreated': 'Ingen fakturaer ble opprettet.', 'sale.list.missingEmailNotice': '{count} fakturaer er opprettet for kunder uten e-post og må sendes eller skrives ut manuelt: {names}', 'sale.list.notCreatedNotice': 'Ikke fullført for: {names}', 'sale.list.createdNoEmail': 'Fakturaen er opprettet, men kunden mangler e-post. Send eller skriv den ut manuelt.', 'sale.list.noneSent': 'Fakturaene er opprettet, men ingen ble sendt på e-post. Send eller skriv ut manuelt: {names}', 'sale.list.recipientsCount': '{count} mottakere', 'sale.list.sentPartly': 'Sendt til {sent} mottakere. Ikke sendt: {names}', 'sale.list.sentAll': 'Sendt til {sent} mottakere.',
  'sale.pay.partialMismatchFeeSuffix': ' minus gebyr', 'sale.pay.feeTooHigh': 'Gebyret kan ikke være større enn salget ({gross}).', 'sale.pay.splitMismatchError': 'Delbetalingene ({paid}) må til sammen stemme med salgstotalen minus gebyr ({expected}).', 'sale.product.backendUnavailable': 'Produktlagring er ikke koblet til backend.', 'sale.product.added': 'Produkt "{name}" lagt til', 'sale.product.updated': 'Produkt "{name}" oppdatert', 'sale.product.saveFailed': 'Kunne ikke lagre produktet.', 'sale.create.backendUnavailable': 'Nytt salg er ikke koblet til backend.',
});

